import colors from '@/assets/colors.json'
import layout from '@/View/CMS/project/pages/Layout/layout.vue'
export const projectDetail = { // dashboard object start
    path: 'project/Detail',
    component: layout,
    hidden: false,
    redirect: '/project/pages/:projectId',
    name: 'ProjectDetail',
    meta: {
        breadCrumb: 'ProjectDetail',
        title: 'ProjectDetail',
        icon: '',
        selected: false,
        permission: '',
        routeIcon: 'listingSvg',
        loadPage: 'workPakcages',
        routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
    },
    children: [
      {
        path: '/projects',
        component: () => import('@/View/CMS/project/projectList.vue'),
        name: 'Projects',
        meta: {
            breadCrumb: 'Projects',
            icon: 'fa fa-project-diagram',
            title: 'Projects',
            routeIcon: 'leftArrowSvg',
            permissionList: ['abc'],
            loadPage: 'leftArrowSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/project/detail/:projectId',
        component: () => import('@/View/CMS/project/pages/component/pages/pageOverView.vue'),
        name: 'PageDetail',
        meta: {
            breadCrumb: 'Pages',
            permissionList: ['IsAdmin'],
            // permissionList: ['abc'],
            icon: 'fa fa-project-diagram',
            title: 'Project Detail',
            routeIcon: 'InfoCircleSvg',
            loadPage: 'InfoCircleSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/pages/:projectId',
        component: () => import('@/View/CMS/project/pages/pages/bloglist.vue'),
        name: 'Pages',
        meta: {
            breadCrumb: 'Pages',
            icon: 'fa fa-project-diagram',
            title: 'Pages',
            permissionList: ['abc'],
            routeIcon: 'pageSvg',
            loadPage: 'listingSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/project/pages/:projectId',
        component: () => import('@/View/CMS/project/pages/component/specificPageList.vue'),
        name: 'specificProject',
        hidden: true,
        meta: {
          breadCrumb: 'specificProject',
          icon: 'fas fa-info-circle',
          title: 'Work Packages',
          selected: false,
          permissionList: ['abc'],
          routeIcon: '',
          // routeIcon: 'ProjectsSvg',
          routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/lead/:projectId',
        component: () => import('@/View/CMS/project/pages/lead/leadlist.vue'),
        name: 'Lead',
        meta: {
            breadCrumb: 'Lead',
            icon: 'fa fa-project-diagram',
            title: 'Lead',
            permissionList: ['abc'],
            routeIcon: 'userSvg',
            loadPage: 'listingSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/component/:projectId',
        component: () => import('@/View/CMS/project/pages/component/components/componentList.vue'),
        name: 'Components',
        meta: {
            breadCrumb: 'Components',
            icon: 'fa fa-project-diagram',
            title: 'Component',
            // permissionList: ['IsAdmin'],
            permissionList: ['abc'],
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/blog/:projectId',
        component: () => import('@/View/CMS/project/pages/blog/bloglist.vue'),
        name: 'Blog',
        meta: {
            breadCrumb: 'Blog',
            icon: 'fa fa-project-diagram',
            title: 'Blog',
            permissionList: ['abc'],
            routeIcon: 'blogSvg',
            loadPage: 'listingSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/filemanager/:projectId',
        component: () => import('@/View/CMS/project/pages/folder/folderlist.vue'),
        name: 'FolderData',
        meta: {
            breadCrumb: 'FolderData',
            icon: 'fa fa-project-diagram',
            title: 'FolderData',
            permissionList: ['abc'],
            routeIcon: 'folderSvg',
            loadPage: 'folderSvg',
            routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
        }
      },
      {
        path: '/blog/component/:projectId/detail/:componentId',
        component: () => import ('@/View/CMS/project/pages/blog/component/componentDetail.vue'),
        name: 'BlogComponentDetail',
        hidden: true,
        meta: {
            breadCrumb: 'BlogComponentDetail',
            icon: 'fa fa-project-diagram',
            title: 'BlogComponentDetail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/component/:projectId/detail/:componentId',
        component: () => import ('@/View/CMS/project/pages/component/components/componentDetail.vue'),
        name: 'ComponentDetail',
        hidden: true,
        meta: {
            breadCrumb: 'ComponentDetail',
            icon: 'fa fa-project-diagram',
            title: 'ComponentDetail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/page/:projectId/detail/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/component/pages/component/pagespecificDetail.vue'),
        name: 'specificPageDetailInPage',
        hidden: true,
        meta: {
            breadCrumb: 'specificPageDetailInPage',
            icon: 'fa fa-project-diagram',
            title: 'Page Detail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/page/:projectId/add/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/component/pages/component/addEditPage.vue'),
        name: 'AddNewPage',
        hidden: true,
        meta: {
            breadCrumb: 'AddNewPage',
            icon: 'fa fa-project-diagram',
            title: 'Page Detail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/page/:projectId/edit/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/component/pages/component/addEditPage.vue'),
        name: 'EditPage',
        hidden: true,
        meta: {
            breadCrumb: 'EditPage',
            icon: 'fa fa-project-diagram',
            title: 'Page Detail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/blog/:projectId/add/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/blog/addEditblog.vue'),
        name: 'AddNewBlog',
        hidden: true,
        meta: {
            breadCrumb: 'AddNewBlog',
            icon: 'fa fa-project-diagram',
            title: 'Blog Add/Edit',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/lead/:projectId/detail/',
        component: () => import ('@/View/CMS/project/pages/lead/leadDetail.vue'),
        name: 'LeadDetail',
        hidden: true,
        meta: {
            breadCrumb: 'LeadDetail',
            icon: 'fa fa-project-diagram',
            title: 'Lead Detail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/blog/:projectId/edit/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/blog/addEditblog.vue'),
        name: 'EditPreBlog',
        hidden: true,
        meta: {
            breadCrumb: 'EditPreBlog',
            icon: 'fa fa-project-diagram',
            title: 'Blog Add/Edit',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/pages/:projectId/edit/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/pages/addEditblog.vue'),
        name: 'EditPrePages',
        hidden: true,
        meta: {
            breadCrumb: 'EditPrePages',
            icon: 'fa fa-project-diagram',
            title: 'Blog Add/Edit',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/blog/components/:projectId',
        component: () => import ('@/View/CMS/project/pages/blog/component/blogCompList.vue'),
        name: 'BlogComponent',
        hidden: true,
        meta: {
            breadCrumb: 'BlogComponent',
            icon: 'fa fa-project-diagram',
            title: 'Blog Component',
            routeIcon: 'blogSvg',
            loadPage: 'listingSvg',
        }
      },
      {
        path: '/blog/:projectId/detail/:pageMasterId',
        component: () => import ('@/View/CMS/project/pages/blog/specificBlogDetail.vue'),
        name: 'BlogSpecificPageDetail',
        hidden: true,
        meta: {
            breadCrumb: 'BlogSpecificPageDetail',
            icon: 'fa fa-project-diagram',
            title: 'Blog Detail',
            routeIcon: 'WorkpackageSvg',
            loadPage: 'listingSvg',
        }
      },
      // {
      //   path: '/pages',
      //   component: () => import('@/View/CMS/project/pages/component/pages/page.vue'),
      //   name: 'Pages',
      //   meta: {
      //       breadCrumb: 'Pages',
      //       icon: 'fa fa-project-diagram',
      //       title: 'Projects',
      //       routeIcon: 'ProjectsSvg',
      //       loadPage: 'listingSvg',
      //       routIconSize: { height: '40px', width: '40px', color:  colors.gray2 }
      //   }
      // }
    ]
}